import { tns } from 'NM/tiny-slider/src/tiny-slider';
import { $, $$ } from '../helpers/selectors';

const SELECTOR = '.stats';
const statsSliderClass = '.js-stats-slider';
const statsRowClass = '.stats__row';
const statsBodyText = '.stats__card-body';
const statsTitleClass = '.stats__card-title';
const statsNumClass = '.stat-text';
const sections = $$(SELECTOR);
let windowResize = null;
class Stats {
  constructor() {
    if (!$(SELECTOR)) {
      return false;
    }

    function handleInitializeSlider() {
      sections.forEach(section => {
        const slideCount = parseInt($(statsSliderClass, section).getAttribute('data-slide-count'));

        if (window.location === window.parent.location) {
          $(statsSliderClass, section).setAttribute('aria-live', 'polite');
        }

        if ((slideCount === 3 || section.classList.contains('stats__non-stats')) && !(section.classList.contains('stats__type--toolkit') && section.classList.contains('stats__non-stats') && slideCount === 2) && slideCount !== 1) {
          const sliders = $$(statsSliderClass, section);

          sliders.forEach(slideItem => {
            if (section.classList.contains('stats__type--toolkit') && section.classList.contains('stats__module') && slideCount === 3) {
              const statsArticleSlider = tns({
                container: slideItem,
                items: 1,
                slideBy: 'page',
                autoplay: false,
                center: false,
                loop: false,
                controls: false,
                navPosition: 'bottom',
                preventScrollOnTouch: 'force',
                responsive: {
                  768: {
                    items: 2,
                  },
                  1024: {
                    items: 2,
                  },
                  1280: {
                    disable: true,
                    items: 3,
                  },
                },
              });

              statsArticleSlider.events.on('indexChanged', info => {
                if (info.displayIndex === info.slideCount) {
                  slideItem.closest('.stats__row').classList.add('stats__row--hide-fade');
                } else {
                  slideItem.closest('.stats__row').classList.remove('stats__row--hide-fade');
                }
              });
            } else {
              const statsSlider = tns({
                container: slideItem,
                items: 1,
                slideBy: 'page',
                autoplay: false,
                center: false,
                loop: false,
                controls: false,
                navPosition: 'bottom',
                preventScrollOnTouch: 'force',
                responsive: {
                  768: {
                    items: 2,
                  },
                  1024: {
                    disable: true,
                    items: 3,
                  },
                },
              });

              statsSlider.events.on('indexChanged', info => {
                if (info.displayIndex === info.slideCount) {
                  slideItem.closest('.stats__row').classList.add('stats__row--hide-fade');
                } else {
                  slideItem.closest('.stats__row').classList.remove('stats__row--hide-fade');
                }
              });
            }
          });

          $$('.tns-nav', section).forEach(navItem => {
            navItem.removeAttribute('aria-label');
          });
        }

        if (slideCount !== 1) {
          handleTitleMinHeight(section);
        }

        handleStatsNumCount(section, slideCount);
      });
    }

    function handleStatsNumCount(section, slideCount) {
      const statsRow = $$(statsRowClass, section);
      statsRow.forEach(row => {
        const statsNumText = $$(statsNumClass, row);
        if (statsNumText) {
          let statsNumMinHeight = 0;

          statsNumText.forEach(item => {
            item.style.removeProperty('min-height');
            const statTextCount = item.textContent.trim().length;

            switch (statTextCount) {
              case 6:
                item.classList.add('stat-text--adjusted-6', 'stat-text--adjusted');
                break;
              case 7:
                item.classList.add('stat-text--adjusted-7', 'stat-text--adjusted');
                if (item.closest('.stats__module')) {
                  item.parentNode.classList.add('stats__content--adjusted');
                }
                break;
              default:
                break;
            }

            if (item.offsetHeight > statsNumMinHeight) {
              statsNumMinHeight = item.offsetHeight;
            }
          });

          if (slideCount !== 1) {
            statsNumText.forEach(item => {
              item.style.minHeight = statsNumMinHeight + 'px';
            });
          }
        }
      });
    }

    function handleTitleMinHeight(section) {
      const statsRow = $$(statsRowClass, section);

      statsRow.forEach(row => {
        let titleMinHeight = 0;
        let bodyMinHeight = 0;
        const titles = $$(statsTitleClass, row);
        const bodyTexts = $$(statsBodyText, row);

        titles.forEach(item => {
          item.style.removeProperty('min-height');
          if (item.offsetHeight > titleMinHeight) {
            titleMinHeight = item.offsetHeight;
          }
        });

        titles.forEach(item => {
          item.style.minHeight = titleMinHeight + 'px';
        });

        bodyTexts.forEach(item => {
          item.style.removeProperty('min-height');
          if (item.offsetHeight > bodyMinHeight) {
            bodyMinHeight = item.offsetHeight;
          }
        });

        bodyTexts.forEach(item => {
          item.style.minHeight = bodyMinHeight + 'px';
        });
      });
    }

    function handleSectionCount() {
      $$('.stats').forEach(item => {
        if (item.nextElementSibling) {
          if (item.classList.contains('stats__module') && item.nextElementSibling.classList.contains('stats__module') && !item.nextElementSibling.classList.contains('adjusted')) {
            item.classList.add('adjusted');
          } else if (item.classList.contains('stats__non-stats') && item.nextElementSibling.classList.contains('stats__non-stats') && !item.nextElementSibling.classList.contains('adjusted')) {
            item.classList.add('adjusted');
          }
        }
      });
    }

    //Initialize Functions
    handleSectionCount();
    handleInitializeSlider();

    // Small Debounce function
    window.addEventListener('resize', function () {
      // clear the timeout
      clearTimeout(windowResize);
      // start timing for event "completion"
      windowResize = setTimeout(handleTitleMinHeight, 350);
    });

    /*function animateCounter(element, start, end, duration, timeoutDuration, decimals) {
      return new Promise((resolve) => {
        console.log(timeoutDuration);
        // Simulate async operation
        setTimeout(() => {
          jQuery({ Counter: start }).animate({ Counter: end }, {
            duration: duration,
            easing: 'swing',
            step: function () {
              jQuery(element).text(parseFloat(this.Counter).toFixed(decimals));
            },
            complete: function () {
              jQuery(element).text(parseFloat(this.Counter).toFixed(decimals));
              jQuery(element).addClass('stats-text--animated');
            }
          });
          resolve();
        }, timeoutDuration);
      });

    }

    async function processItemsSequentially(items) {
      let i = 0;
      for (const item of items) {
        var counterElement = jQuery(this);
        var startValue = 0;
        let endValue = parseFloat(jQuery(item).data('animateInt'));
        console.log(endValue);
        if (i === 0) {
          var timeoutDuration = 0; // in milliseconds
        } else {
          var timeoutDuration = 2000; // in milliseconds
        }
        var animationDuration = 2000; // in milliseconds
        console.log(i);
        if (endValue % 1 === 0) {
          var decimalPlaces = 0;
        } else {
          var decimalPlaces = 2;
        }
        await animateCounter(item, startValue, endValue, animationDuration, timeoutDuration, decimalPlaces);
        i++;
      }
    }

    jQuery(window).on('scroll', function () {
      jQuery('.stats__module').each(function (i) {
        var top_of_element = jQuery(this).offset().top;
        var bottom_of_element = jQuery(this).offset().top + jQuery(this).outerHeight();
        var bottom_of_screen = jQuery(window).scrollTop() + jQuery(window).innerHeight();
        var top_of_screen = jQuery(window).scrollTop();

        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
          // if in viewport, show the animation
          const allItems = jQuery(this)[0].querySelectorAll('.stats-text--number');
          const items = Array.from(allItems).filter(el => !el.classList.contains('stats-text--animated'));
          processItemsSequentially(items);
        }
      });

    });*/
  }
}

export default Stats;
